import { useParams } from 'react-router'
import Page from '@/components/common/Page'
import NewCampaignTab from '@/pages/clients/ClientContent/NewCampaignTab'

export default function CampaignsPage() {
  const { clientId } = useParams<{ clientId: string }>()

  if (!clientId) return null

  return (
    <Page
      title="Campaigns"
      helpContent={{
        header: 'Content Campaigns',
        body: (
          <div>
            <p>Create and manage marketing content campaigns. Define parameters and let Sabar generate content automatically.</p>
            <h4>Campaign Setup:</h4>
            <ul style={{ marginLeft: 20 }}>
              <li>Select content types (blog posts, social media, emails, etc.)</li>
              <li>Define target audience and messaging</li>
              <li>Set tone and brand voice preferences</li>
              <li>Link to business goals for context</li>
            </ul>
            <h4>Next Steps:</h4>
            <p>After creating a campaign, monitor generated content in the Queue. Review and approve items before publication in History.</p>
          </div>
        ),
      }}
    >
      <NewCampaignTab clientId={clientId} />
    </Page>
  )
}
